import { Component } from '@angular/core';

@Component({
  selector: 'app-ppt-vertical-header',
  standalone: false,
  templateUrl: './ppt-vertical-header.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class PptVerticalHeaderComponent{
}
